import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { GraduationCap, ShieldCheck, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AdminLogin = () => {
  const [params] = useSearchParams();
  const err = params.get('err');

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-orange-50 grid place-items-center px-4">
      <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8 max-w-md w-full text-center">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-teal-600 grid place-items-center text-white shadow-md">
          <GraduationCap className="w-7 h-7" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mt-5" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Learndunia Admin
        </h1>
        <p className="text-slate-500 text-sm mt-1">Sign in with your Google account to manage the platform.</p>

        {err && (
          <div className="mt-4 text-xs text-rose-700 bg-rose-50 border border-rose-100 rounded-lg px-3 py-2">
            Sign-in failed. Please try again.
          </div>
        )}

        <Button onClick={startLogin} className="w-full bg-slate-900 hover:bg-slate-800 text-white mt-6 h-11">
          Continue with Google <ArrowRight className="w-4 h-4 ml-1" />
        </Button>

        <div className="mt-5 text-xs text-slate-500 flex items-center gap-1 justify-center">
          <ShieldCheck className="w-3.5 h-3.5" /> Secure Google sign-in
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
